export default "__VITE_ASSET__DuCpxz6k__"